import createCachedSelector from 're-reselect';

const defaultContactPersons = {
  summaryLoaded: false,
  summary: null
};

const getContactPersonsData = (state, partnerId) => state.currentOffer.clientContactPersonsData[partnerId] || defaultContactPersons;

export const getContactPersonsSummaryIsLoaded = createCachedSelector(getContactPersonsData, contactPersons => {
  return contactPersons.summaryLoaded;
})((_, partnerId) => partnerId);

export const getContactPersonsSummary = createCachedSelector(getContactPersonsData, contactPersons => {
  return contactPersons.summary;
})((_, partnerId) => partnerId);
